<template>
	<div class="content flex flex-align-start">
		<div class="flex-1 mr40">
			<div class="flex flex-align-center">
				<div>当前省份：</div>
				<el-select class="ml5" v-model="province" filterable placeholder="请选择" :disabled="!userInfo.vip" :loading="!isReady" @change="chooseProvince">
				    <el-option v-for="(item,index) in provinceList" :key="index" :label="item" :value="item"></el-option>
				</el-select>
			</div>
			
			<el-tabs v-model="TabCur" class="mt20" @tab-click="$event.index != 0 && province && chooseProvince(province)">
				<el-tab-pane :label="item" v-for="(item,index) in tabs" :key="index">
					<div class="mt5" v-if="TabCur == 0">
						<div class="flex flex-align-center">
							<!-- <el-autocomplete style="width: 325px;" v-model="form.school" :disabled="!province" :fetch-suggestions="querySearchAsync" placeholder="请输入院校名称" @select="form.school = $event.value,checkMajor()" @blur="checkMajor()" @input="form.major = '',majors = []"> -->
							<!-- <el-autocomplete style="width: 325px;" v-model="form.school" :disabled="!province" :fetch-suggestions="querySearchAsync" placeholder="请输入院校名称" @select="form.school = $event.value">
								<template slot="prepend">院校名称</template>
							</el-autocomplete> -->
							<el-input style="width: 325px;" :disabled="!province" placeholder="请输入院校名称" v-model="form.school">
							    <template slot="prepend">院校名称</template>
							</el-input>
							
							<!-- <el-autocomplete class="ml30 flex-1" v-model="form.major" :disabled="!province || !form.school" :fetch-suggestions="getMajor" placeholder="请输入专业名称" @select="form.major = $event.value">
								<template slot="prepend">专业名称</template>
							</el-autocomplete> -->
							
							<el-button class="ml30" type="primary" icon="el-icon-search" :loading="loading" :disabled="!province" @click="search()">搜索</el-button>
						</div>
						
						<!-- <el-descriptions class="mt20" title="「搜索结果」" :column="2" border v-if="result.content" v-loading="loading">
						    <el-descriptions-item label="院校名称">{{ result.school }}</el-descriptions-item>
						    <el-descriptions-item label="专业名称">{{ result.major || '--' }}</el-descriptions-item>
							<el-descriptions-item label="结果描述">{{ result.content }}</el-descriptions-item>
						</el-descriptions> -->
						<el-descriptions class="mt20" title="「搜索结果」" :column="1" border :contentStyle="{ width: '660px !important' }" v-if="result.content" v-loading="loading">
						    <el-descriptions-item label="院校名称">{{ result.school }}</el-descriptions-item>
							<el-descriptions-item label="结果描述">{{ result.content }}</el-descriptions-item>
						</el-descriptions>
					</div>
					<div style="min-height: 300px;padding: 5px 0 50px;" v-loading="isLoading" v-else>
						<div style="color: #cccccc;" v-if="!province">请先选择省份</div>
						<div class="" v-else>
							<div class="rich-text" v-html="richText[Number(index) - 1]"></div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		
		<!-- 宣传图 -->
		<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
			<el-carousel-item v-for="(item,index) in swiper" :key="index">
				<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'Targeted',
	data(){
		return{
			provinceList: [],
			province: '',
			
			tabs: ['院校及学科资质查询', '入围院校及学科名单', '其他报考条件', '名单公示'],
			TabCur: '0',
			
			form: {
				school: '',
				major: ''
			},
			
			schools: [],  // 全部学校
			majors: [],  // 全部专业
			
			loading: false,  // 搜索按钮loading
			majorLen: 0,  // 院校的专业数量
			
			// 搜索结果
			result: {
				school: '',
				major: '',
				content: ''
			},
			
			richText: ['', '', '']
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		
		if(this.token) this.getUser()
		
		this.getProvince()
	},
	methods: {
		async getProvince(){
			this.$http.get('/api/webs/search/dxxdsProvince')
			    .then(response => {
			        let res = response.data
					
					this.isReady = true
					this.provinceList = res.list
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		
		async chooseProvince(e){
			this.province = e
			this.isLoading = true
			
			this.$http.get('/api/webs/search/dxxdsOther', { params: { province: e } })
			    .then(response => {
			        let res = response.data
					
					this.isLoading = false
					this.richText[0] = res.dxRwyxjxkmd
					this.richText[1] = res.dxQtbktj
					this.richText[2] = res.dxLymdgs
			    })
			    .catch(error => {
			        console.error(error)
					this.isLoading = false
			    })
				
			this.$http.get('/api/webs/search/dxxdsCollegeNameLike', { params: { province: e } })
				.then(response => {
					let res = response.data
					
					this.schools = res.list.map(v => {
						return { value: v }
					})
				})
				.catch(error => {
					console.error(error)
				})
		},
		
		async querySearchAsync(queryString, cb){
			var results = queryString ? this.schools.filter(v => v.value.includes(queryString)) : this.schools;
			cb(results);
		},
		
		async getMajor(queryString, cb){
			var results = queryString ? this.majors.filter(v => v.value.includes(queryString)) : this.majors;
			cb(results);
		},
		
		// 搜索
		async search(){
			if(!this.form.school) return this.$message({ message: '请输入学校名称', type: 'warning' })
			this.loading = true
			
			// if(!this.form.major && this.majors.length) return this.loading = false,this.$message({ message: '请输入专业名称', type: 'warning' })
			
			let params = {
				province: this.province, 
				collegeName: this.form.school,
				majorName: this.form.major
			}
			this.$http.get('/api/webs/search/dyxds', { params })
				.then(response => {
					let res = response.data
					
					this.loading = false
					
					this.result.school = res.collegeName
					this.result.major = res.majorName
					this.result.content = res.describe
				})
				.catch(error => {
					console.error(error)
					this.loading = false
				})
		},
		
		async checkMajor(){
			if(!this.form.school) return
			this.$http.get('/api/webs/search/dyxdsMajorNameLike', { params: { province: this.province, collegeName: this.form.school } })
				.then(response => {
					let res = response.data
					this.majors = res.list.map(v => {
						return { value: v }
					})
				})
				.catch(error => {
					console.error(error)
				})
		}
	}
}
</script>

<style>
.el-input--suffix{
	width: 160px !important;
}
.el-descriptions-item__label.is-bordered-label{
	width: 140px !important;
}
.el-descriptions-item__content{
	width: 260px !important;
}
</style>